import Repository from "@shared/services/api/abstracts/Repository";
import { UrlRouteMap } from "@shared/services/api/types";
import {
  PublicTrackingTokensSerializer,
  getPublicTrackingTokensRequestParams,
} from "../types";

export default class PublicTrackingTokenRepository extends Repository<PublicTrackingTokensSerializer> {
  public readonly repositoryName = "PublicTrackingTokenRepository";

  public readonly endpoint = "api/public/analytics/tracking";

  public get urlMap(): UrlRouteMap {
    return {
      ...this.defaultUrlMap,
      getPublicTrackingTokens: "tokens",
    };
  }

  public getPublicTrackingTokens = async (
    params?: getPublicTrackingTokensRequestParams
  ): Promise<PublicTrackingTokensSerializer> => {
    const { data } = await this.request(
      this.buildUrl("getPublicTrackingTokens"),
      {
        method: "get",
        params,
      }
    );
    return data;
  };
}
